const formatDate = (date) =>
    {
    return new Date(date).toLocaleDateString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric" });
    }

const formatDateWithTime = (date) => {
    return new Date(date).toLocaleDateString("pl-PL", { 
        day: "2-digit", 
        month: "2-digit", 
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    }).replace(",", ""); // Usuwa przecinek pomiędzy datą a godziną
};


export {formatDate, formatDateWithTime};